import React from "react";
import { RaisedButton, CircularProgress } from "material-ui";
import { Link, Redirect } from "react-router";
import Helmet from "react-helmet";
import pickBy from "lodash/pickBy";

import connectToStores from "alt-utils/lib/connectToStores";
import PersonStore from "../stores/PersonStore";
import PassStore from "../stores/PassStore";
import PassActions from "../actions/PassActions";

const SCANNER_SCRIPT_URL =
  "https://unpkg.com/html5-qrcode@2.3.4/html5-qrcode.min.js";

@connectToStores
class CheckPass extends React.Component {
  constructor(props) {
    super(props);
    this.renderScanner = this.renderScanner.bind(this);
    this.onScan = this.onScan.bind(this);
  }
  static getStores() {
    return [PersonStore, PassStore];
  }

  static get contextTypes() {
    return {
      router: React.PropTypes.object.isRequired,
      tenant: React.PropTypes.object,
      appSettings: React.PropTypes.object
    };
  }

  static getPropsFromStores() {
    var props = PassStore.getState();
    props.getPassesForCurrentEventBucket =
      PassStore.getPassesForCurrentEventBucket;
    props.isLoggedIn = PersonStore.getState().isLoggedIn;
    props.email =
      PersonStore.getState().details && PersonStore.getState().details.email;
    return props;
  }

  componentDidMount() {
    PassActions.fetchAll();

    if (!document.querySelector(`script[src="${SCANNER_SCRIPT_URL}"]`)) {
      var script = document.createElement("script");
      script.type = "text/javascript";
      script.src = SCANNER_SCRIPT_URL;
      script.onload = () => setTimeout(this.renderScanner, 250);
      document.body.appendChild(script);
    } else {
      this.renderScanner();
    }
  }

  componentWillReceiveProps(newProps) {
    if (!newProps.isLoggedIn) {
      setTimeout(
        () =>
          this.context.router.push(
            `/login?next=${encodeURIComponent("/check_pass")}`
          ),
        10
      );
    }

    // On login, fetch all passes - triggered on login from accept-transfer modal
    if (newProps.isLoggedIn !== this.props.isLoggedIn) {
      PassActions.fetchAll.defer();
    }
  }

  getStyles() {
    return {
      container: {
        padding: 10,
        textAlign: "center"
      },
      intro: {
        padding: 15,
        fontSize: "12pt",
        lineHeight: 1.5,
        color: "rgba(0,0,0,0.54)"
      }
    };
  }

  componentWillUnmount() {
    if (this.html5QrcodeScanner) {
      this.html5QrcodeScanner.stop();
      this.html5QrcodeScanner = null;
    }
  }

  renderScanner() {
    try {
      if (this.html5QrcodeScanner) {
        this.html5QrcodeScanner.stop();
        this.html5QrcodeScanner = null;
      }
      this.html5QrcodeScanner = new window.Html5Qrcode("CheckPassReader");
      const config = { fps: 10, qrbox: { width: 150, height: 150 } };
      this.html5QrcodeScanner.start(
        { facingMode: "environment" },
        config,
        this.onScan
      );
    } catch (e) {
      console.error(e);
    }
  }

  onScan(id) {
    let passes = this.props.getPassesForCurrentEventBucket();

    const hasPass = passes[id];
    if (hasPass) {
      window.alert(
        `You're all set! This pass is already connected to your account. No action is required.`
      );
    } else {
      window.alert(
        `ACTION REQUIRED: This pass is not connected to your account. Please contact the festival team to have your pass re-printed.`
      );
    }
  }

  render() {
    const styles = this.getStyles();

    if (!this.props.isLoggedIn) {
      return <div />;
    }

    return (
      <div
        className="Eventive--passes Eventive--passes--hasPasses"
        style={styles.container}
      >
        <Helmet title={`Check my pass`} />
        <div style={styles.intro}>
          Scan a pass QR code to confirm that it is connected to your account.
          You are currently logged in as <strong>{this.props.email}</strong>.
        </div>

        <div>
          <div
            id="CheckPassReader"
            style={{
              width: "90%",
              maxWidth: 400,
              margin: "0 auto"
            }}
          ></div>
          <style>{`img[alt="Info icon"] { display: none; }`}</style>
        </div>
      </div>
    );
  }
}

export default CheckPass;



// WEBPACK FOOTER //
// ./src/app/components/check-pass.jsx